<template>
    <div class="padding-10">
        <a-divider orientation="left">15分钟数据</a-divider>
        <div class="search-div">
            <div class="table-page-search-wrapper">
                <a-form layout="inline">
                    <a-row :gutter="12">

                        <a-col :md="6" :sm="24">
                            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol"  label="气象站">
                                <weather-station-select-station ref="inverterSelect"  @changeWeather="changeWeather"></weather-station-select-station>
                            </a-form-item>
                        </a-col>

                        <a-col :md="6" :sm="24">
                            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol"  label="时间范围">
                                <select-date ref="selectDate" @getDateRange="getDateRange"></select-date>
                            </a-form-item>
                        </a-col>




                        <a-col :md="6" :sm="24">
                            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol"  label=" " :colon="false">
                             <span class="table-page-search-submitButtons">
                              <a-button type="primary" @click="initTable">查询</a-button>
                             </span>
                            </a-form-item>
                        </a-col>
                    </a-row>
                </a-form>
            </div>
        </div>

        <div class="table-tools">
            <a-form layout="inline" >

                <a-form-item>
                    <a-button-group>
                        <a-button  @click="exportData"><i class="fa fa-cloud-download icon"></i> 导出</a-button>
                    </a-button-group>
                </a-form-item>
            </a-form>


            <div class="table-tools-right">
                <a-icon type="sync" @click="initTable" />
                <table-columns :columns="columns" @getFilterColumns="getColumns" :rowKey="record=>record.id">
                </table-columns>
            </div>
        </div>
        <div class="table">
            <a-table :loading="loading"
                     :columns="filterColumns"
                     :dataSource="data"
                     bordered
                     @change="changeOrder"
                     :pagination="pagination"
                     :scroll="{y: 600}"
            >
                   <span slot="id" slot-scope="text, record, index">
                        <template>
                            <span>{{index + 1}}</span>
                        </template>
                  </span>
            </a-table>
        </div>

    </div>
</template>

<script>
    import TableColumns from "@/components/TableColumn/TableColumns";
    import stationSelectList from "../../../components/common/stationSelectList";
    import weatherStationSelectStation from "@/views/components/common/weatherStationSelectStation";
    import selectDate from "@/components/selectDate/selectDate";

    const columns = [
        {
            title: 'id',
            key: 'id',
            dataIndex: 'id',
            show: true,
            sorter: true,
            width: 80,
            scopedSlots: {customRender: "id"},
        },
        {
            title: '气象站名',
            key: 'weatherStationName',
            dataIndex: 'weatherStationName',
            show: true,
            width: 150,
            sorter: true
        },
        {
            title: '序列号',
            key: 'sequence',
            dataIndex: 'sequence',
            show: true,
            width: 100,
            sorter: true
        },
        {
            title: '实时辐照(W/m²)',
            key: 'totalTBQ',
            dataIndex: 'totalTBQ',
            show: true,
            width: 100,
            sorter: true
        },
        {
            title: '当日累计辐照(MJ/m2)',
            key: 'totalTBQAcc',
            dataIndex: 'totalTBQAcc',
            show: true,
            width: 100,
            sorter: true
        },
        {
            title: '组件温度(°C)',
            key: 'pasterTemp',
            dataIndex: 'pasterTemp',
            show: true,
            width: 100,
            sorter: true
        },
        {
            title: '数据采集时间',
            key: 'createTime',
            dataIndex: 'createTime',
            show: true,
            width: 100,
            sorter: true
        },


    ];

    export default {
        name: "fifteenMinutes",
        components:{
            TableColumns,
            stationSelectList,
            weatherStationSelectStation,
            selectDate
        },
        data(){
            return {
                labelCol: {
                    span: 6
                },
                columns,
                data: [],
                filterColumns:[],
                haha: '',
                queryParam:{
                    station: 0,
                    startTime: 'null',
                    endTime: 'null',
                    weather: 3,
                },
                selectData: {
                    station: [],
                    weather: [],
                },
                queryParams:{
                    sortName: 'id',
                    sortOrder: 'desc',
                    page: 1,
                    size: 50
                },
                order: {
                    ascend: 'asc',
                    descend: 'desc'
                },
                loading: false,
                stationName: '',
                pagination: {
                    total: 0,
                    current: 1,
                    defaultPageSize: 50,
                    showSizeChanger: true,
                    pageSizeOptions: ['50','100','200','300']
                },
                groupId: this.$Utils.getUserStorage().groupId,
                stationId: this.$Utils.getUserStorage().powerStationId,
                username: null
            }
        },
        mounted(){
            this.username = this.$Utils.getUserStorage().username;
            this.groupId = this.$Utils.getUserStorage().groupId;
            this.initTableColumns();
            this.$refs.inverterSelect.init();
        },
        methods:{
            initTableColumns(){
                this.filterColumns = this.columns.filter(item => item.show);
            },
            getColumns(data){
                this.filterColumns = data;
            },
            changeWeather(id){
                this.queryParam.weather = id;
                this.initTable();
                this.$refs.selectDate.init("3"); //3 是选择日期类型
            },

            getDateRange(date){
                console.log(date)
                this.queryParam.startTime = date.start;
                this.queryParam.endTime = date.end;
                this.initTable();
            },

            changeOrder(pagination, filters, sorter){
                console.log(pagination ,sorter)
                this.queryParams.page = pagination.current;
                this.queryParams.sortName = sorter.columnKey ? sorter.columnKey : 'id';
                this.queryParams.sortOrder = sorter.order ? this.order[sorter.order] : 'desc';
                this.initTable()
            },

            async initTable(){
                this.loading = true;
                let result = await this.$http.get(this.$baseURL.fifteenMinuteReport({groupId: this.groupId, powerStationId: this.stationId, weatherStationId: this.queryParam.weather, beginTimeNum: this.queryParam.startTime,endTimeNum: this.queryParam.endTime}, this.queryParams));
                console.log(result)
                this.data = result.list;
                this.pagination.current = result.pageNum;
                this.pagination.total = result.total;
                this.loading = false;

                console.log(this.pagination)
            },
            async exportData(){
                let result = await this.$http.get(this.$baseURL.fifteenExportExcel({username: this.username}), 1)
                this.$Utils.showInfo({title: '文件下载', msg: '生成文件需要一点时间,完成后会自动下载...'})
            }

        },
        computed:{
            wrapperCol(){
                return {span: 24 - this.labelCol.span};
            }
        }
    }
</script>

<style lang="less">
    .table /deep/ .ant-table-thead > tr > th, .ant-table-tbody > tr > td {
        padding: 16px 16px;
        word-break: break-word;
        -ms-word-break: break-all;
    }
</style>
